import React from 'react';
import { TabbedForm, FormTab } from 'react-admin';
import DetailsTab from './Details';
import { makeStyles } from '@material-ui/core/styles';
import EvidenceTab from './Evidence';
import SuspectsTab from './Suspects';
import SleuthTab from './Sleuth';

const useStyles = makeStyles({
  container: {
    width: 'auto',
  },
});

const EventTabs = ({
  hasCreate,
  hasEdit,
  hasList,
  hasShow,
  mutationMode,
  save,
  saving,
  event,
  ...props
}) => {
  const { resource } = props;
  const classes = useStyles();

  return (
    <TabbedForm {...props} toolbar={null}>
      <FormTab label={`resources.${resource}.tabs.details`}>
        <div className={classes.container}>
          <DetailsTab {...props} event={event}/>
        </div>
      </FormTab>
      <FormTab label={`resources.${resource}.tabs.evidence`}>
        <EvidenceTab {...props} />
      </FormTab>
      <FormTab label={`resources.${resource}.tabs.suspect`}>
        <SuspectsTab {...props} />
      </FormTab>
      <FormTab label={`resources.${resource}.tabs.superSleuth`}>
        <SleuthTab {...props} />
      </FormTab>
    </TabbedForm>
  );
};

export default EventTabs;
